class product {
    f_q = [
        0.0996,                         // link ha un prezzo deciso da EGL
        0.052745, 
        0.054902, 
        0.046385
    ]

    f1_q = [
        0.1067,                         // link ha un prezzo deciso da EGL
        0.05496, 
        0.05482, 
        0.04638
    ]

    f2_q = [
        0.0960,                         // link ha un prezzo deciso da EGL
        0.044238,
        0.047223, 
        0.040126
    ]

    au = {                              // acquirente unico valori per il calcolo del PE forward
        "oneri": 0.000291,              // ????
        "costi": 0.000072               // ????
    }

    constructor () {
    } 
}

export class Sceltasicura extends product {

    constructor () {
        super();

        this.name = 'Sceltasicura';
        this.f = ( this.f_q[0] + this.f_q[1] + this.f_q[2] + this.f_q[3] ) / 4 + this.au.costi + this.au.oneri;
        this.f1 = ( this.f1_q[0] + this.f1_q[1] + this.f1_q[2] + this.f1_q[3] ) / 4 + this.au.costi + this.au.oneri;
        this.f2 = ( this.f2_q[0] + this.f2_q[1] + this.f2_q[2] + this.f2_q[3] ) / 4 + this.au.costi + this.au.oneri;
        
        this.PCV = 65.1239;                  //- autority PCV
        this.PPE = true;
    } 
}

export class Link extends product {  
    
    constructor () {
        super();
        
        this.name = 'Link';
        this.f = this.f_q[0];
        this.f1 = this.f1_q[0];
        this.f2 = this.f2_q[0];
        
        this.PCV = 90;                       //- custom EGL PCV
        this.PPE = false;                    //- false = do not apply to this product
    }
}

export class Scontocerto extends product {  
    
    constructor () {
        super();
        
        this.name = 'Scontocerto';
        this.f = this.f_q[0];
        this.f1 = this.f1_q[0];
        this.f2 = this.f2_q[0];
        
        this.PCV = 120;                      //- custom EGL PCV 120
        this.PPE = false;
    }
}